import { PeopleAction, PeopleActionTypes, PeopleState } from './peopleTypes';

const initialState: PeopleState = {
  loadingPeople: true,
  savingPerson: false,
  removingPerson: false,
  people: [],
  selectedIndex: null,
  isEditing: false,
  searchQuery: '',
  filters: {
    status: 'all',
    under_age: false,
    gender: 'all',
  },
};

export default function peopleReducer(
  state = initialState,
  action: PeopleAction
): PeopleState {
  switch (action.type) {
    case PeopleActionTypes.EDITING_START:
      return {
        ...state,
        isEditing: true,
        selectedIndex: action.index ?? null,
      };

    case PeopleActionTypes.EDITING_CANCEL:
      return {
        ...state,
        isEditing: false,
      };

    case PeopleActionTypes.GET_PEOPLE_START:
      return {
        ...state,
        loadingPeople: true,
      };

    case PeopleActionTypes.GET_PEOPLE_SUCCESS:
      if (!action.people) {
        throw new Error();
      }
      return {
        ...state,
        loadingPeople: false,
        people: action.people,
      };

    case PeopleActionTypes.GET_PEOPLE_ERROR:
      return {
        ...state,
        loadingPeople: false,
      };

    case PeopleActionTypes.SAVE_PERSON_START:
      return {
        ...state,
        savingPerson: true,
      };

    case PeopleActionTypes.SAVE_PERSON_SUCCESS:
      return {
        ...state,
        savingPerson: false,
        selectedIndex: null,
      };

    case PeopleActionTypes.SAVE_PERSON_ERROR:
      return {
        ...state,
        savingPerson: false,
      };

    case PeopleActionTypes.REMOVE_PERSON_START:
      return {
        ...state,
        removingPerson: true,
      };

    case PeopleActionTypes.REMOVE_PERSON_SUCCESS:
      return {
        ...state,
        removingPerson: false,
        selectedIndex: null,
        isEditing: false,
      };

    case PeopleActionTypes.REMOVE_PERSON_ERROR:
      return {
        ...state,
        removingPerson: false,
      };

    case PeopleActionTypes.SET_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.searchQuery || '',
      };

    case PeopleActionTypes.SET_PEOPLE_FILTERS:
      if (!action.filters) {
        throw new Error();
      }
      return {
        ...state,
        filters: action.filters,
      };

    case PeopleActionTypes.CLEAR:
      return initialState;

    default:
      return state;
  }
}
